import { Flex, Button, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { useRouter } from 'next/router';

const GetARide = () => {
  const router = useRouter();

  return (
    <Flex
      width={220}
      backgroundColor="white"
      shadow={'md'}
      rounded={'md'}
      direction={'column'}
      overflow={'hidden'}
    >
      <Image src="/images/gogreen.png" width={220} height={110} alt="image" />
      <Flex direction={'column'} p={'20px'} justifyContent={'center'} mt={4}>
        <Text m={0} fontSize={18} fontWeight={'semibold'}>
          Get yourself a new ride
        </Text>
        <Text m={0} pt={10} fontSize={14}>
          Experience the future of luxury travel with our chauffeur-driven,
          all-electric service. <br />
          <br />
          Your next executive ride is just only tap away.
        </Text>
        <Button
          name="schedule"
          backgroundColor={'brand.900'}
          shadow={'md'}
          color={'white'}
          _hover={{
            opacity: 0.7,
          }}
          fontWeight={'medium'}
          mt={10}
          onClick={() => router.push('/app/order')}
        >
          Schedule Now
        </Button>
      </Flex>
    </Flex>
  );
};

export default GetARide;
